import { computed, inject, Injectable, Signal, signal } from '@angular/core';
import { AsyncApiService } from '@spike/core';
import { ConfirmationDialogService } from '../utility/confirmation-dialog.service';
import { Etiquette } from '../../models/etiquette.model';
import { EntityApiEnum } from 'src/app/config/entity-api.enum';

@Injectable({ providedIn: 'root' })
export class EtiquetteStoreService {
    private readonly confirmationDialogService = inject(ConfirmationDialogService);
    private readonly asyncApiService = inject(AsyncApiService);
    private readonly apiEnum = EntityApiEnum.FIN_ETIQUETTE;
    private readonly list = signal<Etiquette[]>([]);

    constructor() {
        // Caricamento iniziale automatico all'avvio del service
        this.reload();
    }

    public async save(entity: Etiquette) {
        await this.asyncApiService.save(this.apiEnum, entity, entity.etiquetteId ?? undefined);
        await this.reload();
    }

    public async deleteById(id: number) {
        this.confirmationDialogService.show('Sei sicuro di voler eliminare questa etichetta?', async () => {
            await this.deleteByIdConfirmed(id);
        });
    }

    public async deleteByIdConfirmed(id: number) {
        await this.asyncApiService.deleteById(this.apiEnum, id);
        await this.reload();
    }

    public getList(): Signal<Etiquette[]> {
        return this.list.asReadonly();
    }

    private async reload() {
        const res = await this.asyncApiService.selectAll<Etiquette>(this.apiEnum);
        this.list.set(res);
    }

    public findStatic(id: number | undefined): Etiquette | undefined {
        return this.list().find(x => x.etiquetteId === id);
    }
        
    public findReactive(id: number | undefined): Signal<Etiquette | undefined> {
        return computed(() => {
            if (!id) return undefined;
            return this.list().find(x => x.etiquetteId === id);
        });
    }
}